var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUtility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-89",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,22 C8,22 10,26.3685768 10,28.3721713 C10,30.3757658 8.209139,32 6,32 C3.790861,32 2,30.3757658 2,28.3721713 C2,26.3685768 4,22 6,22 Z M6,24.08 L5.90145813,24.1707867 C5.61613953,24.4391294 5.29624583,24.8727007 4.99603805,25.41011 C4.40420648,26.4695623 4,27.7469648 4,28.3721713 C4,29.2252621 4.85421666,30 6,30 C7.14578334,30 8,29.2252621 8,28.3721713 C8,27.7469648 7.59579352,26.4695623 7.00396195,25.41011 C6.70375417,24.8727007 6.38386047,24.4391294 6.09854187,24.1707867 L6,24.08 Z M24,0 C24.5522847,0 25,0.44771525 25,1 C25,1.51283584 24.6139598,1.93550716 24.1166211,1.99327227 L24,2 L15,2 L15,5 L30,5 L30,13 L12.0002441,13 C10.9458823,13 10.082079,13.8158778 10.0057299,14.8507377 L10.0002441,15 L10.0002441,19 C10.0002441,20.0543618 9.18436635,20.9181651 8.14950649,20.9945143 L8.00024414,21 L4,21 C2.9456382,21 2.08183488,20.1841222 2.00548574,19.1492623 L2,19 L2,13 C2,8.66508574 5.44783777,5.13545713 9.75082067,5.00380682 L10,5 L13,5 L13,2 L4,2 C3.44771525,2 3,1.55228475 3,1 C3,0.487164161 3.38604019,0.0644928393 3.88337887,0.00672773133 L4,0 L24,0 Z M28,7 L10,7 C6.76160306,7 4.12242824,9.56557489 4.00413847,12.7750617 L4,13 L4,19 L8.00024414,19 L8.00024414,15 C8.00024414,12.8578046 9.68421261,11.1089211 11.8006038,11.0048953 L12.0002441,11 L28,11 L28,7 Z",
    id: "Combined-Shape",
    fill: "currentColor",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtility);
export default __webpack_public_path__ + "static/media/utility.a3a4637df790aafba594b8eeac16f849.svg";
export { ForwardRef as ReactComponent };